const KpiLine = ({ label, value }) => {
  return (
    <div className="flex flex-row justify-between">
      <div className="text-adq-blue font-semibold">{label}</div>
      <div className="mr-4">{value}</div>
    </div>
  );
};

export default KpiLine;
